import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext, isProfileIncomplete } from './context/AuthContext';

import LandingPage from './pages/LandingPage';
import RegisterPage from './pages/RegisterPage';
import CompleteProfilePage from './pages/CompleteProfilePage';
import VerifyToken from './pages/VerifyToken';
import SendToken from './pages/SendToken';
import EmailVerification from './pages/EmailVerification';
import Services from './pages/Services';
import Users from './pages/Users';
import AdminUsersPage from './pages/AdminUsersPage';
import EditServicePage from './pages/EditServicePage';
import ProfilePage from './pages/ProfilePage';
import AdminRequestsPage from './pages/AdminRequestsPage';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import ProviderRegisterPage from "./pages/ProviderRegisterPage";
import ProviderProfilePage from "./pages/ProviderProfilePage";
import AdminProvidersPage from "./pages/AdminProvidersPage";
import ProviderRequestsPage from "./pages/ProviderRequestsPage";
import ProviderQuotesPage from "./pages/ProviderQuotesPage";
import ClientQuotesPage from "./pages/ClientQuotesPage";
import ClientRequestsPage from "./pages/ClientRequestsPage";
import RatingPage from "./pages/RatingPage";
import AdminFormsPage from "./pages/AdminFormsPage";
import ProviderCalendarPage from "./pages/ProviderCalendarPage";
import ChatPage from "./pages/ChatPage";

import { ServiceRequestPage } from './pages/ServiceRequestPage';

const AppRoutes = () => (
  <Router>
    <AppRoutesInner />
  </Router>
);

const AppRoutesInner = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const profileGate = user && isProfileIncomplete(user)
    && location.pathname !== '/completar-perfil';

  return (
    <Routes>
      {/* Rutas públicas */}
      <Route
        path="/"
        element={
          user && location.pathname === '/'
            ? user.role === 'admin'
              ? <Navigate to="/admin/users" />
              : <Navigate to="/services" />
            : <LandingPage />
        }
      />
      <Route path="/registro" element={<RegisterPage />} />
      <Route path="/completar-perfil" element={<CompleteProfilePage />} />
      <Route path="/verificar" element={<VerifyToken />} />
      <Route path="/solicitar" element={<SendToken />} />
      <Route path="/verificacion" element={<EmailVerification />} />

      {/* Rutas protegidas con layout */}
      <Route element={
        !user
          ? <Navigate to="/" />
          : profileGate
            ? <Navigate to="/completar-perfil" />
            : <Layout />
      }>
        <Route path="/services" element={<PrivateRoute><Services /></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute requiredRole="admin"><Users /></PrivateRoute>} />
        <Route path="/admin/users" element={<PrivateRoute requiredRole="admin"><AdminUsersPage /></PrivateRoute>} />
        <Route path="/services/edit/:id" element={<PrivateRoute requiredRole="admin"><EditServicePage /></PrivateRoute>} />
        <Route path="/perfil" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
        <Route path="/admin/requests" element={<PrivateRoute requiredRole="admin"><AdminRequestsPage /></PrivateRoute>} />
        <Route path="/solicitar/:serviceKey" element={<PrivateRoute><ServiceRequestPageWrapper /></PrivateRoute>} />

        {/* Panel de solicitudes del cliente */}
        <Route path="/mis-solicitudes" element={<PrivateRoute><ClientRequestsPage /></PrivateRoute>} />
        <Route path="/mis-solicitudes/:requestId/presupuestos" element={<PrivateRoute><ClientQuotesPage /></PrivateRoute>} />

        {/* Calificaciones */}
        <Route path="/calificar/:requestId" element={<PrivateRoute><RatingPage /></PrivateRoute>} />

        {/* Chat — Etapa 8 */}
        <Route path="/chat/:requestId" element={<PrivateRoute><ChatPage /></PrivateRoute>} />

        {/* Módulo prestadores */}
        <Route path="/prestador/registro"     element={<PrivateRoute><ProviderRegisterPage /></PrivateRoute>} />
        <Route path="/prestador/perfil"       element={<PrivateRoute><ProviderProfilePage /></PrivateRoute>} />
        <Route path="/prestador/solicitudes"  element={<PrivateRoute><ProviderRequestsPage /></PrivateRoute>} />
        <Route path="/prestador/presupuestos" element={<PrivateRoute><ProviderQuotesPage /></PrivateRoute>} />
        <Route path="/prestador/agenda"       element={<PrivateRoute><ProviderCalendarPage /></PrivateRoute>} />

        {/* Admin */}
        <Route path="/admin/prestadores"  element={<PrivateRoute requiredRole="admin"><AdminProvidersPage /></PrivateRoute>} />
        <Route path="/admin/formularios"  element={<PrivateRoute requiredRole="admin"><AdminFormsPage /></PrivateRoute>} />
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

function ServiceRequestPageWrapper() {
  const { serviceKey } = useParams();
  return <ServiceRequestPage serviceKey={serviceKey} />;
}

export default AppRoutes;
